import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { S3PdfPageSelectionEdit } from "./edit";
import { S3PdfPageSelectionNew } from "./new";
import { S3PdfPageSelectionTable } from "./table";

export default function S3PdfPageSelection() {
  const { t, i18n } = useTranslation(["titles"]);

  useEffect(() => {
    setDocumentTitle(
      t("quantilia_s_lection_de_pages_pdf", {
        ns: "titles",
        defaultValue: "Quantilia | PDF Page Selection",
      }),
    );
  }, [t, i18n.language]);

  return (
    <Routes>
      <Route path=":id" element={<S3PdfPageSelectionEdit />} />
      <Route index element={<S3PdfPageSelectionTable />} />
      <Route path="/new" element={<S3PdfPageSelectionNew />} />
    </Routes>
  );
}
